var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_9772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.8335C13.0304 5.8335 13.5391 6.04421 13.9142 6.41928C14.2893 6.79435 14.5 7.30306 14.5 7.8335C14.5 8.36393 14.2893 8.87264 13.9142 9.24771C13.5391 9.62278 13.0304 9.8335 12.5 9.8335",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1665 5.8335V13.1668C7.1665 13.3436 7.09627 13.5132 6.97124 13.6382C6.84622 13.7633 6.67665 13.8335 6.49984 13.8335H5.83317C5.65636 13.8335 5.48679 13.7633 5.36177 13.6382C5.23674 13.5132 5.1665 13.3436 5.1665 13.1668V9.8335",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.83346L11.516 3.32013C11.6036 3.24713 11.7103 3.20063 11.8234 3.18606C11.9365 3.1715 12.0514 3.18948 12.1547 3.2379C12.258 3.28631 12.3453 3.36316 12.4065 3.45943C12.4676 3.5557 12.5001 3.66741 12.5 3.78146V11.8855C12.5001 11.9995 12.4676 12.1112 12.4065 12.2075C12.3453 12.3038 12.258 12.3806 12.1547 12.429C12.0514 12.4774 11.9365 12.4954 11.8234 12.4809C11.7103 12.4663 11.6036 12.4198 11.516 12.3468L8.5 9.83346H3.16667C2.98986 9.83346 2.82029 9.76322 2.69526 9.6382C2.57024 9.51317 2.5 9.34361 2.5 9.16679V6.50013C2.5 6.32332 2.57024 6.15375 2.69526 6.02872C2.82029 5.9037 2.98986 5.83346 3.16667 5.83346H8.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_9772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/speakerphone.b0050f028c1b2755db485e9895556f3f.svg";
export { ForwardRef as ReactComponent };